import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './NotFound.css';

const NotFound = () => (
  <div className="not-found-page">
    <Helmet>
      <title>Página não encontrada | Loucas por Beleza</title>
    </Helmet>
    <div className="container">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <p className="not-found-text">Página não encontrada.</p>
        <Link to="/" className="btn-secondary">Voltar à página inicial</Link>
      </div>
    </div>
  </div>
);

export default NotFound;
